(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ShadowItControllerV2', ["$scope", "$routeParams", "modulesManager", "routeHelper", "widgetSettings", "securityEventTypes", function ($scope, $routeParams, modulesManager, routeHelper, widgetSettings, securityEventTypes) {
        var resolutionUuid = '9dce8ff7-2adb-49a2-8dae-60b65e3d05e7';
        $scope.model = {
            resolution: widgetSettings.param(resolutionUuid, 'resolution') || 'month',
            eventStates: ['new'],
            enabledSaases: [],
            selectedSaases: []
        };
        var activeApp = $routeParams.app;
        $scope.allSaasActive = !activeApp;
        $scope.allSaasHref = routeHelper.getHref('shadow-it');
        $scope.allSaasLogoClass = securityEventTypes.get('shadow_it').iconClass;
        var availableSaases = [
            'shadow_it_cp',
            'office365_emails',
            'google_mail'
        ];
        $scope.model.enabledSaases = _(modulesManager.securityEventsSaasApps()).filter(function (saas) {
            return _(availableSaases).contains(saas.name);
        }).map(function (saas) {
            return $.extend({
                href: routeHelper.getHref('shadow-it-per-app', { app: saas.name }),
                show: !activeApp || activeApp === saas.name,
                active: activeApp === saas.name
            }, saas);
        });
        $scope.$watch('model.resolution', function (newValue) {
            widgetSettings.param(resolutionUuid, 'resolution', newValue);
        });
        $scope.updateSelectedSaas = function () {
            $scope.model.selectedSaases = _($scope.model.enabledSaases).filter(function (saas) {
                return saas.show;
            });
        };
        $scope.updateSelectedSaas();
        if (activeApp && !$scope.model.selectedSaases.length) {
            routeHelper.redirectTo('shadow-it');
        }
    }]);
}());